export default __webpack_public_path__ + "static/media/2.a6221ab1.png";